// Pitstop Analysis Page
import React, { useEffect } from 'react';
import PitstopAnalysis from '../components/PitstopAnalysis';

const PitstopAnalysisPage = () => {
  useEffect(() => {
    document.title = 'Sydney Ferris - F1 Pitstop Analysis';
  }, []);
  return (
    <div className="min-h-screen theme-bg-secondary">
      <div className="max-w-7xl mx-auto px-4 py-8">
        <PitstopAnalysis />
      </div>
    </div>
  );
};

export default PitstopAnalysisPage;
